import { NetworkService } from "./NetworkService";

export default class MedicalRecordsService {
  network
  constructor(ntw: NetworkService) {
    this.network = ntw
  }
  list(filters) {
    return this.network.get(this.network.endpoints.medicalRecords, filters);
  }
  show(id) {
    return this.network.get(`${this.network.endpoints.medicalRecords}/${id}`);
  }
}
